import { Core_SOP } from './CoreSOP';
import { FrontDesk_SOP } from './FrontDeskSOP';
import { Grooming_SOP } from './GroomingSOP';
import { Daycare_SOP } from './DaycareSOP';
import { Boarding_SOP } from './BoardingSOP';
import { Training_SOP } from './TrainingSOP';
import { Shuttle_SOP } from './ShuttleSOP';
import { Manager_SOP } from './ManagerSOP';

export const CORE_CONCEPT_DETAILS = {
    ...Core_SOP,
    ...FrontDesk_SOP,
    ...Grooming_SOP,
    ...Daycare_SOP,
    ...Boarding_SOP,   
    ...Training_SOP,
    ...Shuttle_SOP,
    ...Manager_SOP
};